import React from 'react';
const stats = [{
  value: '+1.800',
  label: 'estudiantes confían'
}, {
  value: '6+6',
  label: 'Tomos + Bonos'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}, {
  value: '🇦🇷',
  label: 'Todo el país'
}];
const testimonials = [{
  initials: 'MR',
  quote: '"Tenía Dietoterapia del Adulto en 3 semanas y no sabía por dónde empezar. Con el Megapack encontré todo organizado por patología, con los cálculos paso a paso. Aprobé con 9."',
  author: '— Martina R., Córdoba | 4° año Nutrición UNC'
}, {
  initials: 'JV',
  quote: '"Lo que más me sirvió fue el Pocket de Prácticas Hospitalarias. Llegué a la rotación sabiendo exactamente cómo hacer la valoración nutricional sin que me agarre el pánico frente al paciente."',
  author: '— Julián V., Buenos Aires | 5° año Nutrición UBA'
}, {
  initials: 'CP',
  quote: '"Antes juntaba apuntes de 10 compañeros distintos y nada coincidía. El Megapack tiene todo en un solo lugar, con el lenguaje que piden en los exámenes. Ya aprobé 4 materias con él."',
  author: '— Camila P., Rosario | 3° año Nutrición UNR'
}];
export function SocialProof() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(220,252,231) 15%, rgb(220,252,231) 85%, rgb(240,253,244) 100%)'
  }} data-id="element-270">
      <div className="mx-auto max-w-4xl" data-id="element-271">

        {/* ── STATS GRID ── */}
        <div className="mb-8 grid grid-cols-2 md:grid-cols-4 gap-3 text-center" data-id="element-272">
          {stats.map(stat => <div key={stat.label} data-id="element-273">
              <div className="text-2xl sm:text-4xl leading-[32px] sm:leading-[40px] font-black text-gray-900" data-id="element-274">
                {stat.value}
              </div>
              <div className="mt-1 text-[10px] sm:text-xs font-semibold text-green-700" data-id="element-275">
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* ── TESTIMONIALS GRID ── */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-276">
          {testimonials.map(t => <div key={t.initials} className="flex items-start gap-2 bg-white/80 border border-green-400/30 rounded-lg p-3 shadow-sm" data-id="element-277">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-black text-green-700" style={{
            background: 'linear-gradient(135deg, rgba(21,128,61,0.12) 0%, rgba(34,197,94,0.12) 100%)'
          }} data-id="element-278">
                {t.initials}
              </div>
              <div data-id="element-279">
                <div className="mb-1 text-[10px] text-green-600" data-id="element-280">
                  ⭐⭐⭐⭐⭐
                </div>
                <p className="text-xs font-medium text-gray-900 m-0" data-id="element-281">
                  {t.quote}
                </p>
                <p className="text-[10px] text-gray-500 mt-1 mb-0" data-id="element-282">
                  {t.author}
                </p>
              </div>
            </div>)}
        </div>

      </div>
    </section>;
}